// removed by extract-text-webpack-plugin
module.exports = {"header":"_3KyyC _37W4X _2AJrG","picker":"_1_ONh","heading":"qDG3R _3TD8R _2z9kb GjCgU","footer":"_30c9y _3TD8R _2z9kb _2Hk-A","options":"_1Gj3C _2Cz_3 _2XN97 _2neoE","option":"_1N0JU _1a-AI _18-EI","optionContent":"_17I8h PYP7R _2XN97 _38618 _3Dqep _3TD8R","optionBackground":"_1csl0 Y2_Z-","selected":"_2jwpl","name":"_1El4N","mainIcon":"_2db6G _3K4no _9DUFn","removeIcon":"_1sB4G VW9bs _9DUFn"};


//////////////////
// WEBPACK FOOTER
// ./questions/components/LabelPicker.css
// module id = 1636
// module chunks = 3